import { useState, useCallback } from 'react'

type UploadState = {
  progress: number
  uploading: boolean
  error: string | null
}

export default function useDirectUpload() {
  const [state, setState] = useState<UploadState>({
    progress: 0,
    uploading: false,
    error: null,
  })

  const upload = useCallback(async (file: File): Promise<string> => {
    const { DirectUpload } = await import('@rails/activestorage')

    return new Promise((resolve, reject) => {
      setState({ progress: 0, uploading: true, error: null })

      const directUpload = new DirectUpload(file, '/rails/active_storage/direct_uploads', {
        directUploadWillStoreFileWithXHR(request: XMLHttpRequest) {
          request.upload.addEventListener('progress', (event: ProgressEvent) => {
            if (event.lengthComputable) {
              const percent = Math.round((event.loaded / event.total) * 100)
              setState(prev => ({ ...prev, progress: percent }))
            }
          })
        },
      })

      directUpload.create((error, blob) => {
        if (error) {
          const message = error instanceof Error ? error.message : String(error)
          setState({ progress: 0, uploading: false, error: message })
          reject(error)
        } else {
          setState({ progress: 100, uploading: false, error: null })
          resolve(blob.signed_id)
        }
      })
    })
  }, [])

  return { upload, ...state }
}
